<template>
  <div v-if="metaData && queriedData" class="md-layout-item">
    <md-card>
      <md-card-header
        v-if="header"
        class="md-card-header-icon"
        :class="header.class"
      >
        <div class="card-icon">
          <md-icon>{{ header.icon }}</md-icon>
        </div>

        <h4 class="title">{{ header.title }}</h4>
      </md-card-header>
      <md-card-actions md-alignment="space-between">
        <div class="md-layout md-layout-item md-size-25">
          <md-field
            v-if="templates && templates.length && !reloading"
            class="card-category md-layout-item md-size-50"
          >
            <label>Sačuvani pregledi</label>
            <md-select @input="setTemplate" v-model="currentTemplate">
              <md-option
                v-for="(option, index) in templates"
                :key="index"
                :value="index"
                >{{ option.name }}</md-option
              >
            </md-select>
          </md-field>
          <md-field
            v-if="metaData.total > pagination.perPageOptions[0]"
            class="card-category md-layout-item md-size-50 md-medium-size-100"
          >
            <label for="pages">Po strani</label>
            <md-select v-model="pagination.perPage" name="pages">
              <md-option
                v-for="item in pagination.perPageOptions"
                :key="item"
                :class="
                  item <= 75
                    ? 'md-success'
                    : item <= 100
                    ? 'md-warning'
                    : 'md-danger'
                "
                :label="item"
                :value="item"
              >
                {{ item + (item > 100 ? ' !' : '') }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <slot name="header"></slot>

        <div>
          <pagination
            v-if="metaData.total > pagination.perPage"
            class="pagination-no-border pagination-brand"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="metaData.total"
            @input="getItems"
          >
          </pagination>
          <div class="md-layout">
            <md-button
              @click="sendParam"
              class="md-info md-simple md-just-icon md-round md-offset"
            >
              <md-icon> cached </md-icon>
            </md-button>
            <md-button
              @click="printTable"
              class="md-primary md-simple md-just-icon md-round md-offset"
            >
              <md-icon> print </md-icon>
            </md-button>
          </div>
        </div>
      </md-card-actions>
      <md-card-content>
        <md-table
          v-if="!reloading"
          :value="moddedData"
          :md-sort.sync="currentSort"
          :md-sort-order.sync="currentSortOrder"
          :md-sort-fn="customSort"
          class="paginated-table table-striped table-hover"
        >
          <md-table-toolbar>
            <div v-for="(column, index) in columnParams" :key="index">
              <md-field v-if="column.type === 'text'">
                <label>{{ column.label }}</label>
                {{ initParam(column.name, '') }}
                <md-input
                  type="text"
                  v-model="params[column.name]"
                  :name="column.name"
                  @blur="sendParam"
                  @keyup.enter="sendParam"
                >
                </md-input>
              </md-field>

              <md-field v-else-if="column.type === 'id'">
                <label>{{ column.label }}</label>
                {{ initParam(column.name) }}
                <md-input
                  type="text"
                  v-model="params[column.name]"
                  :name="column.name"
                  @blur="sendParam"
                  @keyup.enter="sendParam"
                >
                </md-input>
              </md-field>

              <div v-else-if="column.type === 'number'">
                <div class="md-layout toolbar-number">
                  <md-field class="md-layout md-layout-item md-size-100">
                    <label>{{ `${column.label} min` }}</label>
                    {{ initParam(column.name) }}
                    <md-input
                      type="number"
                      v-model="params[column.name][0]"
                      :name="column.name"
                      @blur="sendParam"
                      @keyup.enter="sendParam"
                    >
                    </md-input>
                  </md-field>
                  <md-field class="md-layout md-layout-item md-size-100">
                    <label>{{ `${column.label} max` }}</label>
                    <md-input
                      type="number"
                      v-model="params[column.name][1]"
                      :name="column.name"
                      @blur="sendParam"
                      @keyup.enter="sendParam"
                    >
                    </md-input>
                  </md-field>
                </div>
              </div>

              <div v-else-if="column.type === 'date'">
                <div class="md-layout toolbar-date">
                  <md-field class="md-layout md-layout-item md-size-100">
                    <label>{{ `${column.label} min` }}</label>
                    {{ initParam(column.name) }}
                    <md-datepicker
                      v-model="params[column.name][0]"
                      :name="column.name"
                      @input="sendDateParam"
                    />
                  </md-field>
                  <md-field class="md-layout md-layout-item md-size-100">
                    <label>{{ `${column.label} max` }}</label>
                    <md-datepicker
                      v-model="params[column.name][1]"
                      :name="column.name"
                      @input="sendDateParam"
                    />
                  </md-field>
                </div>
              </div>

              <md-field
                v-else-if="column.type === 'boolean'"
                class="toolbar-boolean"
              >
                <label>{{ column.label }}</label>
                {{ initParam(column.name, ['1', '0']) }}
                <md-select
                  v-model="params[column.name]"
                  :name="column.name"
                  multiple
                  @input="sendParam"
                  keyup.enter="sendParam"
                >
                  <md-option value="1">Da</md-option>
                  <md-option value="0">Ne</md-option>
                </md-select>
              </md-field>

              <md-field
                v-else-if="
                  column.type === 'select' || column.type === 'int_select'
                "
              >
                <label>{{ column.label }}</label>
                {{
                  initParam(column.name, [
                    'all',
                    ...column.options.map(option => option.name),
                  ])
                }}
                <md-select
                  v-model="params[column.name]"
                  :name="column.name"
                  :ref="column.name"
                  multiple
                  @input="
                    fillUpList(column.name);
                    sendParam();
                  "
                >
                  <md-option value="all"> Svi </md-option>
                  <md-option
                    v-for="(option, index) in column.options"
                    :key="index"
                    :value="option.name"
                    >{{ option.label }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </md-table-toolbar>

          <md-table-row
            slot="md-table-row"
            slot-scope="{ item, index }"
            class="cursor-on-hover"
            :class="{
              'highlight-row':
                lastIndex === item.id && !['first', 'last'].includes(item.type),
              'group-highlight-row': highlightRows.includes(
                normalizeIndex(index),
              ),
            }"
            @click="
              [
                ['first', 'last'].includes(item.type)
                  ? newItem()
                  : openItemFunc(item),
              ]
            "
          >
            <md-table-cell v-if="forEachSelected" class="checkbox-cell">
              <md-checkbox
                v-if="index === 0"
                v-model="selectedAll"
                @change="selectAll"
                class="first-checkbox"
                :class="someChecked && !selectedAll && 'some-selected-checkbox'"
              >
                <zoom-center-transition
                  ><div
                    v-if="someChecked && !selectedAll"
                    class="black-dash"
                  ></div
                ></zoom-center-transition>
              </md-checkbox>
              <md-checkbox
                v-if="!['first', 'last'].includes(item.type)"
                v-model="checked[newItem ? index - 1 : index]"
                @change="updateSomeChecked"
                class="table-checkbox"
              >
              </md-checkbox>
            </md-table-cell>
            <template v-for="(column, index) in metaData.columnParams">
              <md-table-cell
                v-if="column.type !== 'hidden'"
                :key="index"
                :md-label="column.label"
                :md-sort-by="column.name"
                :class="column.class ? column.class : ''"
              >
                <md-icon v-if="['first', 'last'].includes(item.type)">
                  add
                </md-icon>
                <md-icon
                  v-else-if="column.icon && column.icon[item[column.name]]"
                  :style="
                    column.icon[item[column.name]].color
                      ? `color: ${column.icon[item[column.name]].color};`
                      : ''
                  "
                >
                  {{ column.icon[item[column.name]].icon }}
                </md-icon>
                <md-icon
                  v-else-if="column.type === 'boolean'"
                  :style="item[column.name] ? trueCell.style : falseCell.style"
                >
                  {{ item[column.name] ? trueCell.icon : falseCell.icon }}
                </md-icon>
                <img
                  v-else-if="column.type === 'image'"
                  :src="item[column.name]"
                  class="search-table-img"
                />

                <span v-else> {{ cutString(item[column.name]) }} </span>
              </md-table-cell>
            </template>
            <md-table-cell
              v-if="individualFunction && individualFunction.length"
              md-label="Operacije"
              class="operations-cell"
            >
              <div
                v-if="!['first', 'last'].includes(item.type)"
                class="operations-cell-buttons"
              >
                <template v-for="(funcItem, index) in individualFunction">
                  <md-button
                    v-if="!funcItem.condition || funcItem.condition(item)"
                    :key="index"
                    class="md-just-icon operation-button"
                    :class="funcItem.class"
                    @click.stop="callIndividualFunction(item, index)"
                  >
                    <md-icon>
                      {{ funcItem.icon }}
                    </md-icon>
                  </md-button>
                </template>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
      <md-card-actions md-alignment="space-between">
        <div class="">
          <md-button
            v-for="(button, index) in forEachSelected"
            :key="index"
            :class="someChecked ? button.class : 'md-disabled'"
            :disabled="!someChecked"
            @click="forAllFunc(index)"
          >
            <md-icon>
              {{ button.icon }}
            </md-icon>
            {{ button.label }}
          </md-button>
          <p class="card-category">
            Na prikazu {{ from + 1 }}. do {{ to }}. od ukupno
            {{ metaData.total }}
            {{ cases(metaData.total, 'reda', 'reda', 'redova') }}
          </p>
        </div>
        <pagination
          v-if="metaData.total > pagination.perPage"
          class="pagination-no-border pagination-brand"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="metaData.total"
          @input="getItems"
        >
        </pagination>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { Pagination } from '@/components';
import services from '@/api/services';
import api from '@/api/api.js';
import Swal from 'sweetalert2';
import { cases } from '@/utils/helpers';
import { ZoomCenterTransition } from 'vue2-transitions';
import { openPdfInNewTab } from '../utils/helpers';

export default {
  name: 'SearchTable',
  components: {
    Pagination,
    ZoomCenterTransition,
  },
  props: {
    header: Object,
    metaData: Object,
    queriedData: Array,
    getItems: Function,
    params: Object,
    sortBy: String,
    newItem: Function,
    openItem: Function,
    templates: Array,
    forEachSelected: Array,
    individualFunction: Array,
    queryable: {
      type: Boolean,
      default: true,
    },
    highlightRows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.metaData.total < highBound) {
        highBound = this.metaData.total;
      }
      return highBound;
    },
    moddedData() {
      if (this.newItem) {
        return [{ type: 'first' }]
          .concat(this.queriedData)
          .concat([{ type: 'last' }]);
      } else {
        return this.queriedData;
      }
    },
    columnParams() {
      return this.metaData.columnParams.filter(
        param => param.type !== 'hidden',
      );
    },
  },
  data() {
    return {
      currentSort: '',
      currentSortOrder: 'desc',
      loaded: false,
      trueCell: {
        icon: 'done_outline',
        style: 'color: green',
      },
      falseCell: {
        icon: 'hourglass_disabled',
        style: 'color: red',
      },
      pagination: {
        currentPage: 1,
        perPage: 75,
        perPageOptions: [25, 50, 75, 100, 250, 500, 1000, 5000],
      },
      total: null,
      lastIndex: null,
      reloading: false,
      template: null,
      checked: [],
      selectedAll: false,
      someChecked: false,
      keyForReloading: true,
      currentTemplate: null,
      lastParamSent: null,
      dateParamWait: 1500,
    };
  },
  methods: {
    customSort() {
      this.getItems();
    },
    initParam(param, value = null) {
      if (!this.params[param]) {
        this.params[param] = value;
      }
    },
    sendParam() {
      this.pagination.currentPage = 1;
      const query = {};
      for (const [key, value] of Object.entries(this.$route.query)) {
        query[key] = value;
      }
      if (this.queryable) {
        if (this.params.id) {
          query.paramId = this.params.id;
        } else if (query.paramId) {
          delete query.paramId;
        }
        if (JSON.stringify(this.$route.query) !== JSON.stringify(query))
          this.$router.replace({ query });
      }

      this.lastParamSent = Date.now();
      this.getItems();
    },
    sendDateParam() {
      if (Date.now() - this.lastParamSent <= this.dateParamWait) return;
      this.sendParam();
    },
    fillUpList(param) {
      if (this.params[param].find(el => el === 'all')) {
        this.params[param] = ['all'].concat(
          this.metaData.columnParams
            .find(el => el.name === param)
            .options.map(el => el.name),
        );
        this.reloading = true;
        this.$nextTick().then(() => {
          // Add the component back in
          this.reloading = false;
        });
      }
    },
    openItemFunc(value) {
      this.lastIndex = value.id;

      this.openItem(value);
    },
    cases(num, unitary, few, multiple) {
      return cases(num, unitary, few, multiple);
    },
    normalizeIndex(index) {
      if (this.newItem) return index - 1;
      return index;
    },
    selectAll() {
      this.checked = this.checked.map(() => this.selectedAll);
      this.updateSomeChecked();
    },
    forAllFunc(index) {
      const items = this.queriedData.filter((_, i) => this.checked[i]);

      if (this.forEachSelected[index].arg)
        this.forEachSelected[index].function(
          items,
          this.forEachSelected[index].arg,
        );
      else this.forEachSelected[index].function(items);
    },
    callIndividualFunction(data, index) {
      this.individualFunction[index].function(data);
    },
    setTemplate(param = null) {
      if (param === null && this.template !== null) param = this.template;
      if (param !== null) {
        this.template = param;
        Object.assign(this.params, this.templates[param].params);
        this.sendParam();
        // this.$forceUpdate()
        this.reloading = true;
        this.$nextTick().then(() => {
          // Add the component back in
          this.reloading = false;
        });
      }
    },
    printTable() {
      Promise.resolve(this.getItems(true)).then(() => {
        let additionalFields = this.getAdditionalFields();
        let html = '<div class="additional-fields"><h4>Izaberi kolone</h4>';
        this.metaData.columnParams.forEach(column => {
          if (column.type === 'hidden') return;
          html = `${html} 
            <div>
              <label for="${column.name}-check">
                ${column.label}
              </label>
              <input id="${column.name}-check" type="checkbox" checked="true">
              </input>
            </div>`;
        });
        html = `${html}</div>`;

        if (additionalFields.length) {
          html = `${html}
                <div class="additional-fields">
                <h5>Dodatna polja</h5>`;

          additionalFields.forEach((field, index) => {
            html = `${html}
                <div>
                  <label for="additional-field-${index}">
                    ${field}
                  </label>
                  <input id="additional-field-${index}" type="checkbox" checked="true"  class="additional-field-check">
                  </input>
                </div>`;
          });
          html = `${html}
                </div>`;
        }

        Swal.fire({
          title: 'Štampaj tabelu?',
          html,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-info btn-fill',
          cancelButtonClass: 'md-button btn-fill',
          confirmButtonText: 'Štampaj',
          cancelButtonText: 'Otkaži',
          buttonsStyling: false,
        }).then(data => {
          if (data.value) {
            if (additionalFields.length) {
              const checks = document.querySelectorAll(
                '.additional-field-check',
              );
              additionalFields = additionalFields.filter(
                (_, i) => checks[i].checked,
              );
            }

            const requestParams = {
              printTable: true,
              tableName: this.$route.name,
              total:
                this.metaData.total > this.pagination.perPage
                  ? this.pagination.perPage
                  : this.metaData.total,
              chosenColumns: JSON.stringify(
                this.metaData.columnParams
                  .filter(column => {
                    let checkbox;
                    if (column.type === 'hidden') {
                      return false;
                    } else {
                      checkbox = document.getElementById(
                        `${column.name}-check`,
                      );
                      return checkbox.checked;
                    }
                  })
                  .map(column => column.name),
              ),
              additionalFields: JSON.stringify(additionalFields),
            };
            api
              .post(services.printTable, requestParams)
              .then(pdfData => openPdfInNewTab(pdfData))
              .catch(error => {
                this.alertError(error);
              });
          }
        });
      });
    },
    loopToFindFields(node, fields = []) {
      for (let i = 0; i < node.childNodes.length; i++) {
        const child = node.childNodes[i];
        this.loopToFindFields(child, fields);
        if (child.nodeType === Node.TEXT_NODE) {
          const text = child.wholeText;
          if (text.match(/\w+?: -?\d+.*/)) fields.push(text);
        }
      }
      return fields;
    },
    getAdditionalFields() {
      const elements = document.querySelector('body');
      return this.loopToFindFields(elements, []);
    },
    cutString(value) {
      if (value === null) return;
      const limit = 50;
      const string = String(value);
      return string.length > limit
        ? `${string.slice(0, limit - 3)}...`
        : string;
    },
    updateSomeChecked() {
      this.someChecked = this.checked.some(el => el);
      this.selectedAll = this.checked.every(el => el);
    },
    removeChecked() {
      this.checked = this.checked.map(() => false);
      this.updateSomeChecked();
    },
  },
  mounted() {
    if (this.$route.query.paramId) this.params.id = this.$route.query.paramId;
    if (this.sortBy) this.currentSort = this.sortBy;
    this.queriedData.forEach((el, index) => {
      this.checked[index] = false;
    });
  },
  watch: {
    sortBy: {
      handler(to) {
        this.currentSort = to;
      },
    },
    queriedData: {
      handler(to, from) {
        if (!from.length)
          to.forEach((el, index) => {
            this.checked[index] = this.checked[index] ?? false;
          });
      },
    },
    'metaData.columnParams': {
      handler() {
        this.keyForReloading = false;
        this.$nextTick(() => {
          this.keyForReloading = true;
        });
      },
      deep: true,
    },
    checked: {
      handler(to) {
        this.$emit('checked', to);
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/md/_colors.scss';
.hidden {
  display: none;
}
.md-toolbar {
  align-items: flex-end;
}
.toolbar-number {
  max-width: 150px;
  position: relative;
  /* top: -30px; */
  padding-top: 30px;
}
.table-hover {
  position: relative;
  max-height: 75em;
  overflow-y: auto;
}
.toolbar-date {
  min-width: 150px;
  max-width: 200px;
  position: relative;
  /* top: -30px; */
  padding-top: 30px;
}
.toolbar-date .md-datepicker {
  margin-top: 10px;
}
.toolbar-date label {
  margin-top: -0.7em;
  margin-left: 2.5em;
}
.md-table-row {
  cursor: pointer;
}
.search-table-img {
  height: 2em;
  width: 2em;
  border: 1px solid #5f5f5f;
  border-radius: 50%;
  box-shadow: 2px 2px 3px 1px #bebebe;
}

.highlight-row {
  background-color: #9ed6e2 !important;
}
.group-highlight-row {
  background-color: #dbf4f7 !important;
}
.md-checkbox.table-checkbox {
  margin: 0 0 0 0;
}
.checkbox-cell {
  width: 10px;
}
.operations-cell {
  padding-right: 1em !important;
  white-space: nowrap;
  text-align: right;
}
.operations-cell-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.5em;
}
.toolbar-boolean {
  width: 10em !important;
}
.first-checkbox {
  position: absolute;
  top: -2.4em;
  left: 0.35em;
  z-index: 10;
  margin: 0;
}
.last-checkbox {
  position: relative;
  top: 2em;
}
.operation-button {
  margin: 0 !important;
}
.black-dash {
  position: absolute;
  width: 15px;
  height: 3px;
  background-color: $blue-grey-800;
  border-radius: 2px;
  left: -18px;
  top: 7px;
}
</style>
